module.exports = __webpack_public_path__ + "img/3.d4c2e2d8.png";